import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class PosService {

    constructor(private http: HttpClient) { }

    // Get list of Pos Providers - platform wide
    public getAllPosProviders() {
        return this.http.get(environment.apiUrl + 'api/ext-pos-provider')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    public getPosConfigByStore(storeid) {
        return this.http.get(environment.apiUrl + 'api/ext-pos-config/by-store/' + storeid)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    public createPosConfig(obj) {
        // const body = {
        //     eposStoreId: obj.eposStoreId,
        //     posProviderId: obj.posProviderId,
        //     premierToken: obj.premierToken,
        //     premierUrl: obj.premierUrl,
        //     storeId: storeid
        // };
        return this.http.post(environment.apiUrl + 'api/ext-pos-config', obj)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/pos.service.ts